export const NAME = 'ecpay';